<template>
    <v-card>
        <v-card-title>
            <v-img src="https://cell-0.com/img/cell-0-logo.png" contain />
        </v-card-title>
        <v-card-title>
            <h2>Cell[0]</h2>
        </v-card-title>
        <v-card-text>
            Klokgebouw 197<br />
            5617 AB Eindhoven<br />
            <br />
            +31 40 3041457<br />
            <br />
            <a href="mailto:info@cell-0.com">info@cell-0.com</a>

        </v-card-text>
        <v-card-actions>
            <v-btn to="https://cell-0.com" block>
                Website
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import demos from '../../../demos'

export default {
    props: {
        message: {
            required: true,
        },
        context: {
            required: true,
        },
    },
    computed: {
        demoName () {
            if (!this.message.entities[0]) {
                return
            }
            return this.message.entities[0].option
        },
        demo () {
            if (!this.demoName) {
                return null
            }

            return demos.state.demos.find((demo) => {
                return demo.name === this.demoName
            })
        },
    },
}
</script>
